import { ControllerRenderProps } from "react-hook-form";

import { AgentPlaygroundFormValues } from "src/agents/AgentVersionPage/AgentPlayground";
import {
  PLAYGROUND_ACCEPTED_FILE_TYPES,
  PLAYGROUND_FILE_UPLOAD_DESCRIPTION,
  PLAYGROUND_MAX_FILE_SIZE_BYTES,
} from "src/agents/AgentVersionPage/playgroundFileConstants";
import { FileUpload, useFileUpload } from "src/base-components/FileUpload";

type PlaygroundFileListFieldProps = {
  field: ControllerRenderProps<
    AgentPlaygroundFormValues,
    `structuredInput.${string}`
  >;
  fieldName: string;
  disabled?: boolean;
};

export const PlaygroundFileListField: React.FC<
  PlaygroundFileListFieldProps
> = ({ field, fieldName, disabled = false }) => {
  const { fileUploadProps } = useFileUpload({
    multiple: true,
    env: "sandbox",
    source: "agent-playground",
    value: field.value as string[] | undefined,
    onChange: field.onChange,
    disabled,
  });

  return (
    <FileUpload
      {...fileUploadProps}
      accept={PLAYGROUND_ACCEPTED_FILE_TYPES}
      dataLoc={`playground-filelist-${fieldName}`}
      description={PLAYGROUND_FILE_UPLOAD_DESCRIPTION}
      floatingWindowOffset={[0, 600]}
      floatingWindowPlacement="left"
      maxSize={PLAYGROUND_MAX_FILE_SIZE_BYTES}
    />
  );
};
